import { Joi } from '@ksyos/koi';
import type { IFetchResult } from '../store/fetch';
import { fetchJson } from '../store/fetch';

export class OverlapChecker {
    private lastCheckPromise: Promise<IFetchResult>;

    constructor(private url: string) {}

    public async check(
        params: { [propType: string]: string | undefined | null },
        startDate?: string | Date | null,
        endDate?: string | Date | null,
        excludeId?: string
    ) {
        const startDateValidateResult = Joi.date().required().validate(startDate);
        const endDateValidateResult = Joi.date().validate(endDate || undefined);
        const paramsValid = Object.keys(params).every((key) => Boolean(params[key]));

        if (paramsValid && !startDateValidateResult.error && !endDateValidateResult.error) {
            const paramsQuerystring = Object.keys(params)
                .map((key) => `${key}=${params[key]}`)
                .join('&');
            let url = `${this.url}?${paramsQuerystring}&overlapStartDate=${startDate}`;

            if (endDate) {
                url += '&overlapEndDate=' + endDate;
            }

            if (excludeId) {
                url += '&excludeId=' + excludeId;
            }

            const currentCheckPromise = fetchJson(url, 'GET');
            this.lastCheckPromise = currentCheckPromise;
            const result = await currentCheckPromise;
            if (currentCheckPromise === this.lastCheckPromise) {
                return result.json.items[0];
            }
        }
    }
}
